import {Platform} from 'react-native';
import React from 'react';
import UpdatedComponent from './mockCodePush';
import {REACT_APP_ENV, PARTNER_ID } from '@env';

var Sentry = require('@sentry/react');
var {BrowserTracing} = require('@sentry/tracing');
var CodePush;
var ExpoFonts = require('expo-font');
var ReactNativeIdfaAaid;
var DeviceInfo;

export const globalImport = {
  sentry: Sentry,
  BrowserTracing: BrowserTracing,
  isWeb: Platform.OS === 'web',
  CodePush: UpdatedComponent,
  REACT_APP_ENV,
  PARTNER_ID,
  ExpoFonts: ExpoFonts,
  ReactNativeIdfaAaid: ReactNativeIdfaAaid,
  DeviceInfo: DeviceInfo,
};
